import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"

import Button from "components/ui/Button"
import List from "components/ui/InfoList"
import Title from "components/ui/ModalTitle"
import { formatMoney } from "helpers/formatters"
import { ClientProfileType } from "types"

type Props = {
  amount: number
  onBanklink: () => void
  client: ClientProfileType
}

const NewBatchPayment = ({ amount, onBanklink, client }: Props) => {
  const { t } = useTranslation()

  // TODO: fetch data from api
  // TODO: Change data for all instances
  const items = [
    {
      label: t("features.batch_payment.transfer.list.beneficiary.name"),
      value: "PlusPlus Capital AS",
    },
    {
      label: t("features.batch_payment.transfer.list.beneficiary.account"),
      value: "EE082200221053320710",
    },
    {
      label: t("features.batch_payment.transfer.list.description.title"),
      value: client.reference_number,
    },
    {
      label: t("features.batch_payment.transfer.list.reference.number"),
      value: client.reference_number,
    },
  ]

  return (
    <Container>
      <Title>{t("features.batch_payment.form.title")}</Title>
      <Wrapper>
        <Amount variant="h1">{formatMoney(amount)}</Amount>
        <List items={items} />
      </Wrapper>
      <Toggle onClick={onBanklink}>
        {t("features.batch_payment.toggle.banklink")}
      </Toggle>
    </Container>
  )
}

export default NewBatchPayment

const Container = styled(Box)(({ theme }) => ({
  marginTop: "40px",
  [theme.breakpoints.down("lg")]: {
    margin: "0",
  },
}))

const Wrapper = styled(Box)`
  margin: 11px 0 35px 0;
`
const Amount = styled(Typography)`
  font-size: 3.5rem;
  font-weight: 400;
  height: 1.4375em;
  line-height: 1.4375em;
  margin: 0 0 34px 0;
  padding: 0;
  text-align: center;
`
const Toggle = styled(Button)`
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
`
